// extracted by mini-css-extract-plugin
export var avatarContainer = "_49-0";
export var gray = "_49-f";
export var green = "_49-c";
export var icon = "_49-9";
export var image = "_49-1";
export var lg = "_49-6";
export var md = "_49-5";
export var presenceDot = "_49-b";
export var red = "_49-d";
export var sm = "_49-4";
export var status = "_49-a";
export var xl = "_49-7";
export var xs = "_49-3";
export var xxl = "_49-8";
export var xxs = "_49-2";
export var yellow = "_49-e";